export const calendarSvg =
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#19B394" stroke-linecap="round" stroke-linejoin="round" height="24" width="24">
  <path d="M8 2v4" stroke-width="2"></path>
  <path d="M16 2v4" stroke-width="2"></path>
  <path d="M5 4h14s2 0 2 2v14s0 2 -2 2H5s-2 0 -2 -2V6s0 -2 2 -2" stroke-width="2"></path>
  <path d="M3 10h18" stroke-width="2"></path>
</svg>`.trim();
